import { FormInitializerReturnType } from 'src/Configuration/validation'
import { InstallationAccessInviteForm } from '../components/dialogs/InstallationAccessInviteDialog'
import { object, string } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 *  Initializes the form for inviting a user to access an installation
 * @returns initialValues and validationSchema for installation-access form
 */
export const useInstallationAccessInviteFormInitializer = (): FormInitializerReturnType<
  InstallationAccessInviteForm,
  InstallationAccessInviteForm
> => {
  const { t } = useCustomTranslation()
  const initialValues = { email: '' }

  const validationSchema = object().shape({
    email: string().email().required(t('validations.form.email.is-required')),
  })
  return { initialValues, validationSchema }
}
